import { GeneralInvokeOption } from 'src/types';
import {
  getRealRoute,
  encodeUrlQuery,
  checkUrl,
  logErrorAndRunFail
} from '../utils';
import MacleJSBridge from 'src/bridges';
import { APINames, CURRENT_ROUTE, getGlobal } from 'src/shared';

export interface ReLaunchOption extends Partial<GeneralInvokeOption> {
  url: string;
}

/**
 * ```js
 *   ma.miniProgram.reLaunch({
 *     url: '/example',
 *     success: function(res) {},
 *     fail: function(res) {},
 *     complete: function(res) {},
 *   })
 * ```
 */
export function reLaunch(option: ReLaunchOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.MiniProgram.RE_LAUNCH,
      option,
      'parameter error:parameter.url should be String instead of Undefined.'
    );
  }
  const reLaunchOption = option;
  reLaunchOption.url = getRealRoute(
    getGlobal(CURRENT_ROUTE) as string,
    reLaunchOption.url
  );
  reLaunchOption.url = encodeUrlQuery(reLaunchOption.url);

  if (checkUrl(APINames.MiniProgram.RE_LAUNCH, reLaunchOption)) {
    MacleJSBridge.beforeInvoke(APINames.MiniProgram.RE_LAUNCH, reLaunchOption);
  }
}
